export default __webpack_public_path__ + "static/media/tornado.f5f52dca.mpeg";